var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiLayout',{class:_vm.classes,attrs:{"id":"app"}},[_c('BHeader'),_c('UiLayout',[_c('UiLayoutSidebar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSidebar),expression:"showSidebar"}]},[_c('BSidebarMenu')],1),_c('UiLayoutContent',[_c('RouterView')],1)],1),_c('BFooter'),_c('BGlobalErrorMessage'),_c('BModals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }